import { mapGetters, mapMutations, mapActions} from 'vuex';

const _ = require('lodash');

export default {
    props: ['popupType', 'selectedItem','newProduct'],
    data() {
        return {
            toggleInputPrice: false,
            toggleInputCount: false,
            blockAddProduct: false,
            dirtyUpSell: false,
            has_upsell: false,
            // Fiscalization data
            fiscalizationCollapsed: true,
            fiscalizationLoading: false,
            orderReceipts: [],
            creatingReceipt: false,
            canCreateReceiptData: {
                can_create: false,
                cashier: null,
                message: '',
                error_code: null,
            },
            form: {
                department_id: 0,
                customer_name: '',
                email: '',
                address: '',
                country: '',
                phone: 0,
                site: '',
                ip: '',
                comment: '',
                cancel_reason: '0',
                shipment_method_id: 0,
                order_status_id: 1,
                products:[], 
                has_upsell: 0,
            },
            deliveryType:[],
            deliveryChoice: 0,
            ttn:'',
            // Статичні визначення полів: перекладні підписи — labelKey,
            // сам `label` обчислюється в computed fields (залежить від локалі).
            fieldDefs:[
                {
                    key:'id',
                    label:'id',
                },
                {
                    key:'isbn',
                    labelKey:'popupOrder.barcode',
                },
                {
                    key:'product',
                    labelKey:'orders.product',
                },
                {
                    key:'price',
                    labelKey:'popupOrder.price',
                },
                {
                    key:'price_air',
                    labelKey:'popupOrder.air',
                },
                {
                    key:'count',
                    labelKey:'popupOrder.quantity',
                },
                {
                    key:'result',
                    labelKey:'popupOrder.total',
                },
                {
                    key:'orderProductRemove',
                    label:'',
                },
            ],
            tableItems:[],
            tableUpItems:[],
            // Причини відмови відображаються через computed cancelReasonListView
            cancelReasonList:[
                {
                    id:'0',
                },
                {
                    id:'1',
                },
                {
                    id:'2',
                },
                {
                    id:'3',
                },
                {
                    id:'4',
                },
            ],
        }
    },

    computed: {
        fields() {
            return this.fieldDefs.map(field => field.labelKey
                ? { ...field, label: this.$t(field.labelKey) }
                : field);
        },
        cancelReasonListView() {
            // v-select очікує масив з title — добираємо переклад за id
            return this.cancelReasonList.map(item => ({
                id: item.id,
                title: this.$t('popupOrder.cancel_reason_' + item.id),
            }));
        },
        ...mapGetters({
            order:'orders/order',
            departments:'catalog/departments',
            shipmentMethods:'orders/shipmentMethods',
            orderStatusList:'orders/orderStatusList',
            paymentMethods:'orders/paymentMethods',
            usersGroup: 'contacts/usersGroup',
            users:'contacts/users',
            profile:'profile/profile',
        }),
    },
    watch:{
        newProduct(e){
            if(e){ 
                if(!e.is_upsell && this.form.products.find(item => item.product_id === e.product_id && this.tableItems.find(item => item.product_id === e.product_id))){
                    this.tableItems.map(item => {if(+item.product_id === +e.product_id && item.upSell === e.is_upsell){ item.count =  +item.count + +e.quantity}})
                    this.form.products.map(item => {if(+item.product_id === +e.product_id && item.is_upsell === e.is_upsell){ item.quantity =  +item.quantity + +e.quantity}})
                }
                else if(e.is_upsell && this.form.products.find(item => item.product_id === e.product_id && this.tableUpItems.find(item => item.product_id === e.product_id))){
                    this.tableUpItems.map(item => {if(+item.product_id === +e.product_id && item.upSell === e.is_upsell){ item.count =  +item.count + +e.quantity}})
                    this.form.products.map(item => {if(+item.product_id === +e.product_id && item.is_upsell === e.is_upsell){ item.quantity =  +item.quantity + +e.quantity}})
                }else{
                    this.pushTableItem(e)
                    this.form.products.push(e);
                }
            }
        },
        order(e){
            if(e){
                this.form = _.cloneDeep(e)
                this.form.products.map(item => {
                    if (!item.uid) {
                        item.uid = item.id ? 'op_' + item.id : 'tmp_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
                    }
                });
                this.has_upsell = Boolean(e.has_upsell);
                this.tableItems = [];
                this.tableUpItems = [];
                this.form.products.map(item=>{
                    this.pushTableItem(item)
                })
                // Load fiscalization data for existing orders
                this.loadFiscalizationData();
            }
        },
        has_upsell(){
            this.dirtyUpSell = true;
        },
        form(){
            this.changedOrderStatus();
        }
    },
    created() {
        this.getUsers();
        this.getUsersGroup();
        this.shipmentMethods.data.map(item=>{
            this.deliveryType.push(item);
        })
    },
    methods: {
        // Fiscalization methods
        toggleFiscalizationSection() {
            this.fiscalizationCollapsed = !this.fiscalizationCollapsed;
        },
        async loadFiscalizationData() {
            if (!this.order || !this.order.id) return;

            this.fiscalizationLoading = true;
            try {
                // Load receipts
                const receiptsRes = await this.getReceiptsByOrder(this.order.id);
                if (receiptsRes.status) {
                    this.orderReceipts = receiptsRes.data || [];
                }

                // Check if can create receipt
                const canCreateRes = await this.canCreateReceiptAction(this.order.id);
                if (canCreateRes.status && canCreateRes.data) {
                    const payload = canCreateRes.data || {};
                    const models = payload.models || payload.data || {};
                    this.canCreateReceiptData = {
                        can_create: models.can_create != null ? models.can_create : (payload.can_create || false),
                        cashier: models.cashier || payload.cashier || null,
                        message: models.message || payload.message || '',
                        error_code: models.error_code || payload.error_code || null,
                    };
                } else {
                    this.canCreateReceiptData = {
                        can_create: false,
                        cashier: null,
                        message: this.$t('popupOrder.err_check_receipt'),
                        error_code: null,
                    };
                }
            } catch (e) {
                console.error('Error loading fiscalization data:', e);
            } finally {
                this.fiscalizationLoading = false;
            }
        },
        async createReceipt(type) {
            if (!this.order || !this.order.id) {
                this.$toasted.error(this.$t('popupOrder.err_order_not_found'), { duration: 3000 });
                return;
            }

            if (!this.canCreateReceiptData.can_create) {
                this.$toasted.error(this.canCreateReceiptData.message || this.$t('popupOrder.err_cannot_create_receipt'), { duration: 3000 });
                return;
            }

            if (type === 'refund' && !this.orderReceipts.length) {
                this.$toasted.error(this.$t('popupOrder.err_no_receipts_to_refund'), { duration: 3000 });
                return;
            }

            this.creatingReceipt = true;
            try {
                const payload = {
                    order_id: this.order.id,
                    type: type,
                };

                const res = await this.createManualReceipt(payload);
                if (res.status) {
                    this.$toasted.success(type === 'sale' ? this.$t('popupOrder.receipt_sale_created') : this.$t('popupOrder.receipt_refund_created'), { duration: 3000 });
                    // Reload fiscalization data
                    await this.loadFiscalizationData();
                } else {
                    let errorMsg = res.data?.message || this.$t('popupOrder.err_receipt_create');
                    // Check for payment mapping errors
                    if (errorMsg.includes('типи оплат') || errorMsg.includes('payment') || errorMsg.includes('CASH') || errorMsg.includes('CASHLESS')) {
                        errorMsg = this.$t('popupOrder.err_cashier_payment_types');
                    }
                    this.$toasted.error(errorMsg, { duration: 7000 });
                }
            } catch (e) {
                console.error('Error creating receipt:', e);
                this.$toasted.error(this.$t('popupOrder.err_receipt_create'), { duration: 3000 });
            } finally {
                this.creatingReceipt = false;
            }
        },
        changedOrderStatus(){
            if(this.form.order_status_id === 15 || this.form.order_status_id === 22 || this.form.order_status_id === 23){
                this.blockAddProduct = true;
            }else{
                this.blockAddProduct = false;
            }
        },
        removeProduct(productItem){
            if(productItem.upSell === 1){
                this.tableUpItems = this.tableUpItems.filter((item => item.uid !== productItem.uid));
            }else if(productItem.upSell === 0){
                this.tableItems = this.tableItems.filter((item => item.uid !== productItem.uid));
            }
            this.form.products = this.form.products.filter((item => item.uid !== productItem.uid));
            if (productItem.isUnsaved) {
                this.$toasted.success(this.$t('popupOrder.product_deleted'), {
                    duration: 3000
                });
                return;
            }
            this.removeProductInOrder(productItem.id).then(res=>{
                if(res.status){
                    this.$toasted.success(this.$t('popupOrder.product_deleted'), {
                        duration: 3000
                    });
                }else{
                    this.$toasted.error(this.$t('popupOrder.err_delete_product'), {
                        duration: 3000
                    });
                }
            })
        },
        findPhoneOrders(){
            this.$emit('openPhoneOrders')

            const phone = this.form.phone.replace(/\D+/g, "");
            this.getOrdersForPhone({phone: phone})
        },
        pushTableItem(item){
            if(item.is_upsell === 0){
                this.tableItems.push({
                    id: item.id ? item.id : item.product_id,
                    uid: item.uid,
                    isUnsaved: !item.id,
                    isbn: item.product.isbn,
                    product: item.product.title,
                    price: Number(item.price).toFixed(2),
                    price_air: item.price_air ? Number(item.price_air).toFixed(2) : 0,
                    count: Number(item.quantity),
                    result: Number((+item.price + +item.price_air)  * item.quantity).toFixed(2),
                    orderProductRemove: '1',
                    product_id: item.product_id,
                    upSell: 0
                })
            }else if(item.is_upsell === 1){
                this.tableUpItems.push({
                    id: item.id ? item.id : item.product_id,
                    uid: item.uid,
                    isUnsaved: !item.id,
                    isbn: item.product.isbn,
                    product: item.product.title,
                    price: Number(item.price).toFixed(2),
                    price_air: item.price_air ? Number(item.price_air).toFixed(2) : 0,
                    count: Number(item.quantity),
                    result: (+item.price + +item.price_air) * item.quantity,
                    orderProductRemove: '1',
                    product_id: item.product_id,
                    upSell: 1
                });
            }
        },
        updatePrice(value, index, itemProduct){
            this.updateTableItemAllPrice(itemProduct);
            this.form.products.map(item => {
                if(item.uid === itemProduct.uid){
                    item.price = value
                }
            })
        },
        updatePriceAir(value, index, itemProduct){
            this.updateTableItemAllPrice(itemProduct);
            this.form.products.map(item => {
                if(item.uid === itemProduct.uid){
                    item.price_air = value
                }
            })
        },
        updateCount(value, itemProduct){
            this.updateTableItemAllPrice(itemProduct);
            this.form.products.map(item => {
                if(item.uid === itemProduct.uid){
                    item.quantity = value
                }
            })
        },
        updateTableItemAllPrice(itemProduct){
            this.tableUpItems.map(item => {if(+item.product_id === +itemProduct.product_id && item.upSell === itemProduct.upSell){item.result = ((+item.price + +item.price_air) * item.count).toFixed(2)}})
            this.tableItems.map(item => {if(+item.product_id === +itemProduct.product_id && item.upSell === itemProduct.upSell){ item.result = ((+item.price + +item.price_air) * item.count).toFixed(2)}})
        },
        closePopup() {
            this.$emit('closePopup')
        },
        openOrderChangesList(){
            this.$emit('openOrderChangesList', {form: this.form})
        },
        openRememberPopup(){
          this.$emit('togglePopupRemember', {status:true, form: this.form})
        },
        openPopupSearchProduct(){
            this.changeIsUpsell(0);
            this.toggleShowAddProductPopUp(true);
        },
        openPopupUpSellProduct(){
            this.changeIsUpsell(1);
            this.toggleShowAddProductPopUp(true);
        },
        openNpTtn(){
          this.sendChanges(false);
          this.$emit('openNpTtn', {status:true, form: this.form})
        },
        openInfoTtn(){
          this.$emit('openInfoTtn', { id: this.form?.id || this.order?.id || null });
        },
        sendChanges(closeAfter) {
            const phone = this.form.phone.replace(/\D+/g, "");
            const reg = '^\\+?3?8?(0(67|68|96|97|98|66|50|99|95|63|73|93|91)\\d{7})$';
            this.form.has_upsell = Number(this.has_upsell);
            if(phone.toString().match(reg)){
                if(!this.form.employee_id){
                    this.form.employee_id = this.profile.id;
                }
                if(this.order){
                    const payload = {
                        id: this.order.id,
                        data:this.form
                    }
                    this.$emit('changeOrder', {payload: payload, closeAfter: closeAfter})
                }else{
                    this.$emit('sendOrder', {form: this.form, closeAfter: closeAfter})
                }
            }else{
                this.$toasted.error(this.$t('popupOrder.err_wrong_operator_phone'), {
                    duration: 3000
                });
            }
        },
        allPrice(){
            let allPrice = 0;
            if(this.tableItems){
                this.tableItems.map(item=>{
                    allPrice += Number(item.count) * (Number(item.price) + Number(item.price_air));
                })
                return allPrice.toFixed(2);
            }else{
                return 0;
            }
        },
        allCount(){
            let allCount = 0;
            if(this.tableItems){
                this.tableItems.map(item=>{
                    allCount +=  Number(item.count);
                })
                return allCount.toFixed(2);
            }else{
                return 0;
            }
        },
        allUpPrice(){
            let allPrice = 0;
            if(this.tableUpItems.length){
                this.tableUpItems.map(item=>{
                    allPrice += (Number(item.price) + Number(item.price_air)) * Number(item.count)
                })
            }
            return allPrice;
        },
        allUpCount(){
            let allCount = 0;
            this.tableUpItems.map(item=>{
                allCount +=  Number(item.count);
            })
            return allCount;
        },
        showProduct(item){
            this.$emit('showProduct', item.product_id);
        },
        showMassagePopup(){
            this.$emit('showMassage', {status:true, form: this.form});
        },
        showCallHistory(){
            this.$emit('showCallHistory', {status:true});
        },
        statusEdit(id){
            if(id !== 15){
                return true
            }else{
                if(this.profile.user_group_id === 26){
                    return true
                }else{
                    return false
                }
            }
        },
        ...mapActions({
            getUsers:'contacts/getUsers',
            showOrder:'orders/showOrder',
            toggleOrderOpen:'orders/toggleOrderOpen',
            getUsersGroup:'contacts/getUsersGroup',
            getOrdersForPhone:'orders/getOrdersForPhone',
            removeProductInOrder:'orders/removeProductInOrder',
            // Checkbox actions
            getReceiptsByOrder: 'checkbox/getReceiptsByOrder',
            createManualReceipt: 'checkbox/createManualReceipt',
            canCreateReceiptAction: 'checkbox/canCreateReceipt',
        }),
        ...mapMutations({
            toggleShowAddProductPopUp: 'config/toggleShowAddProductPopUp',
            changeIsUpsell: 'orders/changeIsUpsell',
            changeOrder: 'orders/changeOrder',
        }),
    },
    beforeDestroy() {
        if(this.order && this.order.status_open){
            this.toggleOrderOpen(this.order.id)
        }
        this.changeOrder(null);
    }
}
